import graphql from "babel-plugin-relay/macro";

const StockOwnedCountQuery = graphql`
    query StockOwnedCountQuery($stockId: ID) {
        stockOwnedCount(stockId:$stockId)
    }
`;

export default StockOwnedCountQuery;